import { MinimumHoldingClassRealisation } from 'further-types/lp/realisation';

const getHoldingClassRealisation = (
  holdingClassRealisations: Array<MinimumHoldingClassRealisation>,
  holdingClassId: string,
) => {
  const holdingClassRealisation = holdingClassRealisations.find(
    (holdingClassRealisation) =>
      holdingClassRealisation.holdingClassId === holdingClassId,
  );

  if (!holdingClassRealisation) {
    throw new Error('Holding class realisation not found');
  }

  return holdingClassRealisation;
};

export default getHoldingClassRealisation;
